/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SystemStyleObject, Theme } from "@mui/system";

export const streamingMarkdownTextStyles = {
  root: {
    "& > :first-of-type": {
      mt: 0,
    },

    "& > :last-child": {
      mb: 0,
    },

    "& p": {
      my: 1,
    },

    "& ul, & ol": {
      my: 1,
      pl: 3,
    },

    "& li": {
      my: 0.25,
    },

    "& h1": {
      fontSize: "1.45rem",
      fontWeight: 700,
      mt: 2,
      mb: 1,
    },

    "& h2": {
      fontSize: "1.25rem",
      fontWeight: 700,
      mt: 2,
      mb: 1,
    },

    "& h3": {
      fontSize: "1.1rem",
      fontWeight: 700,
      mt: 1.5,
      mb: 0.75,
    },

    "& blockquote": {
      my: 1,
      mx: 0,
      pl: 2,
      borderLeft: "4px solid",
      borderColor: "grey.300",
      color: "text.secondary",
    },

    "& code": {
      px: 0.5,
      py: 0.15,
      borderRadius: 0.75,
      bgcolor: "grey.200",
      fontFamily: "monospace",
      fontSize: "0.9em",
    },

    "& pre": {
      my: 1,
      p: 1.5,
      overflowX: "auto",
      borderRadius: 1,
      bgcolor: "grey.900",
      color: "grey.100",
    },

    "& pre code": {
      p: 0,
      bgcolor: "transparent",
      color: "inherit",
      fontSize: "0.875rem",
    },

    "& table": {
      width: "100%",
      my: 1,
      borderCollapse: "collapse",
    },

    "& th, & td": {
      border: "1px solid",
      borderColor: "grey.300",
      px: 1,
      py: 0.75,
      textAlign: "left",
      verticalAlign: "top",
    },

    "& th": {
      bgcolor: "grey.100",
      fontWeight: 700,
    },

    "& a": {
      color: "primary.main",
      textDecoration: "underline",
      textUnderlineOffset: "2px",
    },
  } satisfies SystemStyleObject<Theme>,
};
